import { useEffect, useState } from "react";
import { getStoredConsent, setConsent } from "@/lib/consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = (decision: "granted" | "denied") => {
    setConsent(decision);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-background/98 backdrop-blur px-5 py-5 md:px-8"
    >
      <div className="mx-auto max-w-7xl flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="text-xs leading-relaxed text-muted-foreground max-w-2xl">
          We use cookies to understand how our site is used and to improve it. Analytics
          cookies are only set if you accept.{" "}
          <a href="/privacy" className="text-foreground underline underline-offset-4">
            Privacy policy
          </a>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            type="button"
            onClick={() => decide("denied")}
            className="flex-1 md:flex-none text-[11px] uppercase tracking-[0.25em] px-5 py-3 border border-border text-foreground hover:bg-accent transition-colors"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => decide("granted")}
            className="flex-1 md:flex-none text-[11px] uppercase tracking-[0.25em] px-5 py-3 bg-foreground text-background hover:bg-foreground/90 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
